import { OrderBook, TradeBook, Positions } from 'sharedweb/app.models';
import {
    UserBookFiltersInterface, TradesResponseDataInterface, PositionsObjResponse, ProductConversionSummaryObj
} from 'sharedweb/app.interface';

export class FilterValidators {

    isValidFilteredOrderBookRow(row: OrderBook, filters: UserBookFiltersInterface) {
        return this.existsInFilter(row.instrument_type, filters.instrument_type) &&
            this.existsInFilter(row.order_status, filters.order_status) &&
            this.existsInFilter(row.scrip_name, filters.scrip_name) &&
            this.existsInFilter(row.order_type, filters.order_type) &&
            this.existsInFilter(row.product_type, filters.product_type) &&
            this.existsInFilter(row.order_mode, filters.side) &&
            this.existsInFilter(row.order_category, filters.order_category);
    }

    isValidFilterdTradeBookRow(row: TradeBook | TradesResponseDataInterface, filters: UserBookFiltersInterface) {
        return this.existsInFilter(row.scrip_name, filters.scrip_name) &&
            this.existsInFilter(row.product_type, filters.product_type) &&
            this.existsInFilter(row.instrument_type, filters.instrument_type) &&
            this.existsInFilter(row.side, filters.side);
    }

    isValidFilteredPositionRow(row: Positions | PositionsObjResponse, filters: UserBookFiltersInterface) {
        return this.existsInFilter(row.instrument_type, filters.instrument_type) &&
            this.existsInFilter(row.scrip_name, filters.scrip_name) &&
            this.existsInFilter(row.product_type, filters.product_type);
    }

    isValidFilteredProductConversionSummaryRow(row: ProductConversionSummaryObj, filters: UserBookFiltersInterface) {
        return this.existsInFilter(row.scrip_name, filters.scrip_name) &&
            this.existsInFilter(row.instrument_type, filters.instrument_type) &&
            this.existsInFilter(row.target_product, filters.product_type) &&
            this.existsInFilter(row.status, filters.status) &&
            this.existsInFilter(row.mode, filters.side);
    }

    /**
     * Method to check if this row value exists in respective filter.
     * If not filter is applied for current check then it will be undefined and throw error,
     * In that case of we return true and add it to book.
     *
     * @param value Value to be checked againt.
     * @param filterArray Array of filter applied if not applied then undefined is passed.
     * @returns "true" if this is a valid row for current filter or filter is not applied else false.
     */
    existsInFilter(value: string | number, filterArray: Array<any>): boolean {

        try {
            return filterArray.includes(value);
        } catch {
            return true;
        }
    }

}
